const styles = `:host{border-collapse:collapse;outline:1px solid var(--goto-border-color-default);border-radius:4px;display:table}`;export default styles;